import React, { useEffect, useState } from 'react';
import { Row, Col } from 'antd';

import { ActivityLog } from 'components/Statistic/ActivityLog';
import { HottestCompanyJobs } from 'components/Statistic/HottestCompanyJobs';
import { MetricsWidget } from 'components/Statistic/MetricsWidget';
import { SurveyUtilizationWidget } from 'components/Statistic/SurveyUtilizationWidget';
import { PricingStatusWidget } from 'components/Statistic/PricingStatusWidget';
import { SurveySeasonBanner } from 'components/SurveySeasonBanner';
import { useFeatureFlag } from 'hooks/featureFlags/useFeatureFlag';
import { formatDate, YEAR_DATE_TIME_TZ_FORMAT } from 'utils/date';
import { FeatureFlag, Plan, PlanService } from 'types';
import cn from './styles.module.scss';

export function Dashboard() {
  const [plan, setPlan] = useState<Plan>();
  const [isLoading, setIsLoading] = useState(false);
  const isSurveySeasonWorkflowEnabled = useFeatureFlag(FeatureFlag.SURVEY_SEASON_WORKFLOW);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const { plans: [plan] } = await PlanService.getPublicPlansList({ includeStats: true, current: true });
      setPlan(plan);
      setIsLoading(false);
    })();
  }, []);

  return (
    <div data-testid="dashboard">
      <Row gutter={[16, 16]}>
        {isSurveySeasonWorkflowEnabled && (
          <Col span={24}>
            <SurveySeasonBanner />
          </Col>
        )}
        <Col span={24}>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <PricingStatusWidget plan={plan} loading={isLoading}/>
            </Col>
            <Col span={8}>
              <MetricsWidget plan={plan} loading={isLoading} />
            </Col>
            <Col span={8}>
              <HottestCompanyJobs
                jobs={plan?.PlanStat?.stats?.hotJobs || []}
                targetChangedCount={plan?.PlanStat?.stats?.hotJobsTargetChanged}
                loading={isLoading}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <SurveyUtilizationWidget planStats={plan?.PlanStat} loading={isLoading} />
            </Col>
            <Col span={12} >
              <ActivityLog className={cn.activityLog} />
            </Col>
          </Row>
        </Col>
      </Row>
      <>
      <div className={cn.infoText}>
      <p>
        </p>*Statistics are updated once per day. {plan?.updatedAt ? `Last update was: ${formatDate(plan.updatedAt, YEAR_DATE_TIME_TZ_FORMAT)}` : ''}
      </div>
      </>
    </div>
  );
}
